import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarLayout from 'components/Layout/Layout';
import { API_URL } from 'env';
import { toast } from "react-toastify";
import { Select } from "antd";

const { Option } = Select;

const AddDailyReading: React.FC = () => {
  const navigate = useNavigate();

  const [locale, setLocale] = useState<string>('en')
  const [form, setForm] = useState({
    number: 0,
    description: {
      en: '',
      vi: '',
    },
    type: 'Annual',
  });

  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    if (locale === 'en') {
      if (!form.description.en.trim()) {
        toast.error("Vui lòng nhập nội dung", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      try {
        setLoading(true);
        const localeData = localStorage.getItem('userData')

        if (localeData) {
          const token = JSON.parse(localeData).access_token

          const response = await fetch(`${API_URL}api/v1/be/coaching-daily-personal`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(form),
          });

          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

          const json = await response.json();

          if (json.status) {
            toast.success("Thêm mới thành công", {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            navigate('/coach-daily');
          } else {
            toast.error('Có lỗi: ' + (json.message || 'Unknown error'), {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } else {
          toast.error('Có lỗi: ' + ('Access denied. Permission required'), {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
        }
      } catch (error: any) {
        toast.error('Lỗi khi thêm mới: ' + error.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      } finally {
        setLoading(false);
      }
    } else if (locale === 'vi') {
      if (!form.description.en.trim()) {
        toast.error("Vui lòng nhập nội dung", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      try {
        setLoading(true);
        const localeData = localStorage.getItem('userData')

        if (localeData) {
          const token = JSON.parse(localeData).access_token

          const response = await fetch(`${API_URL}api/v1/be/coaching-daily-personal`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(form),
          });

          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

          const json = await response.json();

          if (json.status) {
            toast.success("Thêm mới thành công", {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            navigate('/coach-daily');
          } else {
            toast.error('Có lỗi: ' + (json.message || 'Unknown error'), {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } else {
          toast.error('Có lỗi: ' + ('Access denied. Permission required'), {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
        }
      } catch (error: any) {
        toast.error('Lỗi khi thêm mới: ' + error.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <SidebarLayout title={<h4 className="text-2xl font-bold !m-0 py-4">Thêm mới Numerrology</h4>}>
      <div className="p-4 bg-white rounded shadow" >
        <h3 className="text-xl font-bold mb-4" style={{ color: '#5e5873' }}>
          Thông tin chung
        </h3>
        <div className="grid grid-cols-2 gap-4">
          <div className="mb-4">
            <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
              Ngôn ngữ
            </label>
            <Select
              value={locale}
              style={{ width: '100%' }}
              onChange={(e) => setLocale(e)}
              placeholder="Select a language"
            >
              <Option value='vi'>
                Vietnam
              </Option>
              <Option value='en'>
                English
              </Option>
            </Select>
          </div>

          <div className="mb-4">
            <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
              Number
            </label>
            <input
              type="number"
              min="1"
              max="9"
              value={form.number}
              onChange={(e) =>
                setForm({
                  ...form,
                  number: Number(e.target.value),
                })
              }
              className="w-full border p-2 rounded"
              style={{ border: '1px solid #ccc' }}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="mb-4">
            <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
              Type
            </label>
            <Select
              value={form.type}
              style={{ width: '100%' }}
              onChange={(value) => setForm({
                ...form,
                type: value,
              })}
              placeholder="Select a language"
            >
              <Option value='annual'>
                Annual
              </Option>
              <Option value='monthly'>
                Monthly
              </Option>
              <Option value='daily'>
                Daily
              </Option>
            </Select>
          </div>
        </div>
        <div className="mb-4">
          <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
            Nội dung
          </label>
          <div className="border rounded" style={{ border: '1px solid #ccc' }}>
            <textarea value={locale === 'en' ? form.description.en : form.description.vi} onChange={(value) =>
              setForm({
                ...form,
                description: {
                  ...form.description,
                  [locale]: value.target.value,
                },
              })
            } className='w-full p-2' name="" id="" rows={7} />
          </div>
        </div>

        <div className="flex justify-end gap-2">
          <button
            onClick={() => navigate('/coach-daily')}
            className="border px-4 py-2 rounded"
            disabled={loading}
          >
            Hủy
          </button>
          <button
            onClick={handleSave}
            className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
            disabled={loading}
          >
            {loading ? 'Đang xử lý...' : 'Thêm'}
          </button>
        </div>
      </div>
    </SidebarLayout>
  );
};

export default AddDailyReading;
